"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _GridContentMixin = require("../../mixins/components/GridContentMixin");
var _Grid = require("../Grid/Grid");
/**
 * Grid content is a specialized grid item used primariliy for visually containing content within
 * the context of a `Page` component
 * (i.e. providing a background and padding). If you need grid functionality without any
 * visual treatment, you can simply use a `Grid` component
 * instead.
 *
 * This component extends the `Grid` component which has limited
 * support for IE11. See the `Grid` component for more details.
 *
 * @extends Grid
 * @since 8.22.0
 */
var GridContent = /*#__PURE__*/(0, _styledComponents.default)(_Grid.Grid).withConfig({
  displayName: "GridContent",
  componentId: "c11n-8-107-0__sc-14ral2z-0"
})(["", ""], _GridContentMixin.GridContentMixin);
exports.GridContent = GridContent;
GridContent.displayName = 'GridContent';
GridContent.propTypes = {
  /**
   * A color token or `null` to remove the default background color.
   */
  backgroundColor: _propTypes.default.string,
  /**
   * Sets the padding of the content component.
   */
  padding: _propTypes.default.string
};
GridContent.defaultProps = {
  padding: 'sm'
};

/** @component */